@use "sass:meta";

.la-decorate-external-refs__popup {
  position: relative;
  @include meta.load-css("~tippy.js/dist/tippy.css");
  @include meta.load-css("~tippy.js/themes/light-border.css");
  @include meta.load-css("../../styles/tippy");
}
